import type { ApiContext } from "@/api/types";
import { getGroupAuthType } from "@/utils/authToken";
import type {
  GoalAndObjectiveTextResponse,
  GoalsAndObjectivesResponse,
  ModalityTextResponse,
  PatientArticulatedGoalsResponse,
  PatientMedicalCautionsResponse,
  PatientStrengthAndCautionOptionsResponse,
  PatientStrengthsResponse,
} from "@/core/types";
import { GROUP_AUTH_HEADER_NAME } from "@/api/constants";
import { httpAuth2 } from "@/api/auth";

export const carePlanRequestsTyped = {
  get_goal_and_objective_text: function ({
    context,
    patientId,
  }: {
    context?: ApiContext;
    patientId: string;
  }): Promise<GoalAndObjectiveTextResponse> {
    return httpAuth2
      .post(`/v1/care-plan/${patientId}/get_goal_and_objective_text`, {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      })
      .json<GoalAndObjectiveTextResponse>();
  },

  get_goals_and_objectives: function ({
    context,
    patientId,
  }: {
    context?: ApiContext;
    patientId: string;
  }): Promise<GoalsAndObjectivesResponse> {
    return httpAuth2
      .post(`/v1/care-plan/${patientId}/get_goals_and_objectives`, {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      })
      .json<GoalsAndObjectivesResponse>();
  },

  get_modality_text: function ({
    context,
    patientId,
  }: {
    context?: ApiContext;
    patientId: string;
  }): Promise<ModalityTextResponse> {
    return httpAuth2
      .post(`/v1/care-plan/${patientId}/get_modality_text`, {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      })
      .json<ModalityTextResponse>();
  },

  get_patient_articulated_goals: function ({
    context,
    patientId,
  }: {
    context?: ApiContext;
    patientId: string;
  }): Promise<PatientArticulatedGoalsResponse> {
    return httpAuth2
      .post(`/v1/care-plan/${patientId}/get_patient_articulated_goals`, {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      })
      .json<PatientArticulatedGoalsResponse>();
  },

  get_patient_medical_cautions: function ({
    context,
    patientId,
  }: {
    context?: ApiContext;
    patientId: string;
  }): Promise<PatientMedicalCautionsResponse> {
    return httpAuth2
      .post(`/v1/care-plan/${patientId}/get_patient_medical_cautions`, {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      })
      .json<PatientMedicalCautionsResponse>();
  },

  get_patient_strength_and_caution_options: function ({
    context,
    patientId,
  }: {
    context?: ApiContext;
    patientId: string;
  }): Promise<PatientStrengthAndCautionOptionsResponse> {
    return httpAuth2
      .post(`/v1/care-plan/${patientId}/get_patient_strength_and_caution_options`, {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      })
      .json<PatientStrengthAndCautionOptionsResponse>();
  },

  get_patient_strengths: function ({
    context,
    patientId,
  }: {
    context?: ApiContext;
    patientId: string;
  }): Promise<PatientStrengthsResponse> {
    return httpAuth2
      .post(`/v1/care-plan/${patientId}/get_patient_strengths`, {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      })
      .json<PatientStrengthsResponse>();
  },
};
